const locale = {
  month: '{month}个月',
  day: '{day}天',
  hour: '{}小时',
  minute: '{}分钟',
  second: '{}秒',
  timedOut: '已超时',
  moreThanOneMonth: '超过一个月'
};
export default locale;